export default "__VITE_PUBLIC_ASSET__8bdc1f18__"